export function parseAccount(account){return"string"==typeof account?{address:account,type:"json-rpc"}:account}